// Column config for the bulk approval table. Each entry drives a DataGrid
// column with an embedded per-column server-side search control (see
// createSearchColumns / ColumnHeaderSearch). `search` is the control kind; each
// `field` must match a key the backend whitelists in
// BULK_APPROVAL_SEARCHABLE_FIELDS (getUserApprovalItems).

import { formatDate } from "../../../common/functions";

// Date cell: the grid keeps the literal "pending" as-is and otherwise formats.
// (productionDate/expiryDate/receiptDate are free-form strings; requestDate is a
// real date. formatDate tolerates both.)
const dateFormatter = (params) =>
  params.value !== "pending" ? formatDate(params.value) : params.value;

export const bulkApprovalColumnConfig = [
  { field: "itemERPCode", minWidth: 200, search: "text" },
  { field: "itemDescription", minWidth: 200, search: "text" },
  { field: "requesterEmail", minWidth: 200, search: "text" },
  { field: "executiveChefEmail", minWidth: 200, search: "text" },
  { field: "specification", minWidth: 200, search: "text" },
  { field: "preferredUnitOfMeasure", minWidth: 200, search: "text" },
  {
    field: "requestDate",
    minWidth: 180,
    search: "date",
    type: "date",
    csvFormat: "date",
    valueFormatter: dateFormatter,
  },
  {
    field: "productionDate",
    minWidth: 180,
    search: "date",
    csvFormat: "date",
    valueFormatter: dateFormatter,
  },
  {
    field: "expiryDate",
    minWidth: 180,
    search: "date",
    csvFormat: "date",
    valueFormatter: dateFormatter,
  },
  {
    field: "receiptDate",
    minWidth: 180,
    search: "date",
    csvFormat: "date",
    valueFormatter: dateFormatter,
  },
  { field: "erpId", headerName: "Receiver ERP ID", minWidth: 180, search: "text" },
  {
    field: "erpName",
    headerName: "Receiver ERP Name",
    minWidth: 180,
    search: "text",
  },
  { field: "qualityReportsID", minWidth: 220, search: "text" },
  { field: "sampleRequestID", minWidth: 220, search: "text" },
  { field: "sampleItemID", minWidth: 220, search: "text" },
];
